import { useEffect } from 'react';

interface UseKeyboardShortcutsProps {
  isAnimating: boolean;
  setIsEditing: (isEditing: boolean) => void;
  navigation: {
    previousSlide: () => Promise<void>;
    nextSlide: () => Promise<void>;
  };
}

export const useKeyboardShortcuts = ({
  isAnimating,
  setIsEditing,
  navigation,
}: UseKeyboardShortcutsProps) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (isAnimating) return;

      const activeElement = document.activeElement;
      const isTextInput = activeElement && (
        activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA' ||
        (activeElement as HTMLElement).contentEditable === 'true'
      );

      if (isTextInput) return;

      switch (e.key) {
        case 'ArrowLeft':
        case 'ArrowUp':
          e.preventDefault();
          navigation.previousSlide();
          break;
        case 'ArrowRight':
        case 'ArrowDown':
          e.preventDefault();
          navigation.nextSlide();
          break;
        case 'e':
          e.preventDefault();
          setIsEditing(true);
          break;
        case 'p':
        case 'v':
          e.preventDefault();
          setIsEditing(false);
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isAnimating, setIsEditing, navigation]);
};
